// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"427185cb","746":"de3c2a70","858":"708e5ed6"}[chunkId] + ".chunk.js";
};